/* product-page-media.js
   Produktseite:
   - In Liquid sind Bild 1 und 2 bereits rausgefiltert
   - Exakt bei "iPhone 17": zeige JS-Indizes 0, 2, 3
   - Alle anderen Varianten: nur erstes Bild zeigen
   - Kein MutationObserver
*/

(function () {
  if (!location.pathname.includes('/products/')) return;

  function getVariantData() {
    var scripts = Array.from(
      document.querySelectorAll(
        'variant-selects script[type="application/json"], variant-radios script[type="application/json"]'
      )
    );

    for (var i = 0; i < scripts.length; i++) {
      try {
        var data = JSON.parse(scripts[i].textContent);
        if (Array.isArray(data) && data.length) return data;
      } catch (e) {}
    }

    return [];
  }

  function getCurrentVariantFromId() {
    var idInput = document.querySelector('form[action*="/cart/add"] input[name="id"]');
    var currentId = idInput ? String(idInput.value) : '';
    if (!currentId) return null;

    var variants = getVariantData();
    for (var i = 0; i < variants.length; i++) {
      if (String(variants[i].id) === currentId) return variants[i];
    }

    return null;
  }

  function normalizeValue(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/\s+/g, ' ')
      .trim();
  }

  function isExactIphone17(value) {
    return normalizeValue(value) === 'iphone 17';
  }

  function isIphone17Variant() {
    var checkedRadios = document.querySelectorAll('variant-radios input[type="radio"]:checked');
    for (var i = 0; i < checkedRadios.length; i++) {
      if (isExactIphone17(checkedRadios[i].value)) return true;
    }

    var selects = document.querySelectorAll('variant-selects select');
    for (var j = 0; j < selects.length; j++) {
      if (isExactIphone17(selects[j].value)) return true;
    }

    var variant = getCurrentVariantFromId();
    if (!variant) return false;

    return (
      isExactIphone17(variant.option1) ||
      isExactIphone17(variant.option2) ||
      isExactIphone17(variant.option3)
    );
  }

  function getMediaItems() {
    return Array.from(document.querySelectorAll('.product__media-list > li'));
  }

  function getThumbItems() {
    return Array.from(
      document.querySelectorAll('.thumbnail-list li, .thumbnail-list__item, .product__media-sublist li')
    );
  }

  function show(el, displayValue) {
    if (!el) return;
    el.style.setProperty('display', displayValue || '', 'important');
  }

  function hide(el) {
    if (!el) return;
    el.style.setProperty('display', 'none', 'important');
  }

  function applyVisibilityByIndexes(items, visibleIndexes) {
    items.forEach(function (item, index) {
      if (visibleIndexes.indexOf(index) !== -1) {
        show(item, 'list-item');
      } else {
        hide(item);
      }
    });
  }

  function apply() {
    var iphone17 = isIphone17Variant();
    var mediaItems = getMediaItems();
    var thumbItems = getThumbItems();

    if (!mediaItems.length) return;

    if (iphone17) {
      applyVisibilityByIndexes(mediaItems, [0, 2, 3]);
      applyVisibilityByIndexes(thumbItems, [0, 2, 3]);

      var thumbContainers17 = document.querySelectorAll(
        '.thumbnail-slider, .thumbnail-list, .product__media-sublist, slider-component.thumbnail-slider'
      );
      thumbContainers17.forEach(function (el) {
        show(el, '');
      });

      return;
    }

    applyVisibilityByIndexes(mediaItems, [0]);
    applyVisibilityByIndexes(thumbItems, [0]);

    var thumbContainers = document.querySelectorAll(
      '.thumbnail-slider, .thumbnail-list, .product__media-sublist, slider-component.thumbnail-slider'
    );
    thumbContainers.forEach(function (el) {
      hide(el);
    });
  }

  function queueApply() {
    setTimeout(apply, 0);
    setTimeout(apply, 80);
    setTimeout(apply, 180);
    setTimeout(apply, 350);
  }

  function init() {
    queueApply();

    document.addEventListener('change', function (e) {
      if (
        e.target.closest('variant-selects') ||
        e.target.closest('variant-radios') ||
        e.target.name === 'id'
      ) {
        queueApply();
      }
    });

    document.addEventListener('click', function (e) {
      var label = e.target.closest('variant-radios label, variant-radios input, variant-selects select');
      if (label) queueApply();
    }, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* Disable opening zoom/modal when clicking product media */
(function () {
  if (!location.pathname.includes('/products/')) return;

  function isInsideThumbnails(el) {
    return !!(el && el.closest && el.closest('.thumbnail-list, .product__media-sublist'));
  }

  function isVideoControl(el) {
    return !!(el && el.closest && el.closest('video, model-viewer, iframe, .deferred-media__poster-button'));
  }

  function stopZoom(e) {
    const t = e.target;
    if (!t || isInsideThumbnails(t) || isVideoControl(t)) return;

    const opener =
      (t.closest && t.closest('.product__media-toggle')) ||
      (t.closest && t.closest('.product__modal-opener')) ||
      (t.closest && t.closest('modal-opener'));

    if (!opener) return;

    e.preventDefault();
    e.stopImmediatePropagation();
  }

  document.addEventListener('click', stopZoom, true);
  document.addEventListener('pointerup', stopZoom, true);

  document.addEventListener(
    'keydown',
    function (e) {
      if (e.key !== 'Enter' && e.key !== ' ') return;
      stopZoom(e);
    },
    true
  );
})();